import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { color: "default" },
      style: {
        "& .Mui-checked + .MuiSwitch-track": {
          backgroundColor: Colors.GREY600,
        },
      },
    },
  ],
};
